module.exports = __webpack_public_path__ + "img/John Giamporcaro.4138b24a.jpg";